import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import SuccessPage from "../components/SuccessPage";
import { sendPostRequest } from "../utils";

// Whoever reaches this page has probably paid, so a failure must never
// look like a reason to simply pay again
const GENERIC_ERROR =
  "Votre paiement a peut-être été reçu, mais votre inscription n'a pas pu être confirmée. Veuillez communiquer avec Vanessa avant de réessayer.";
const NOTHING_TO_CONFIRM = "Aucun paiement à confirmer.";

const Success = () => {
  const { session_id } = useParams();
  const navigate = useNavigate();

  // loading | done | error
  const [view, setView] = useState(session_id ? "loading" : "error");
  const [error, setError] = useState(session_id ? "" : NOTHING_TO_CONFIRM);

  useEffect(() => {
    if (!session_id) return undefined;
    let isCurrent = true;

    // Safe to repeat: a reload confirms the same sign-up again
    const confirm = async () => {
      try {
        const res = await sendPostRequest("set-subscription", { session_id });
        const data = await res.json();
        if (!isCurrent) return;

        if (data?.subscriptionId) {
          setView("done");
        } else {
          setError(data?.errMessage || GENERIC_ERROR);
          setView("error");
        }
      } catch (err) {
        if (!isCurrent) return;
        setError(GENERIC_ERROR);
        setView("error");
      }
    };

    confirm();
    return () => {
      isCurrent = false;
    };
  }, [session_id]);

  if (view === "done") return <SuccessPage />;

  return (
    <div className="bg-slate-200 min-h-screen flex justify-center items-center p-4">
      <div className="bg-white p-10 rounded-md shadow-md max-w-xl w-full">
        {view === "loading" && (
          <p className="text-lg text-center">Un instant...</p>
        )}

        {view === "error" && (
          <>
            <h1 className="text-3xl font-semibold mb-4 text-center">Oups!</h1>
            <p className="text-lg mb-6 text-center">{error}</p>
            <div className="flex flex-wrap justify-center gap-3">
              <Link
                to="/contact-us"
                className="bg-yellow-600 text-white py-2 px-4 rounded-md hover:bg-yellow-700 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
              >
                Nous joindre
              </Link>
              <button
                className="border border-yellow-600 text-yellow-700 py-2 px-4 rounded-md hover:bg-yellow-50 focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-opacity-50"
                onClick={() => navigate("/")}
              >
                Retour à l'accueil
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Success;
